import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { ERoutes } from "../../../../../AppRouter";

import { SuiviApprenantWalterDetailPage } from "./SuiviApprenantWalterDetailPage";
import { SuiviApprenantHopeDetailPage } from "./SuiviApprenantHopeDetailPage";
import { SuiviApprenantSearchPage } from "./SuiviApprenantSearchPage";

export interface SuiviApprenantProps {
  apprenantId: number;
}

export const SuiviApprenant: React.FunctionComponent<SuiviApprenantProps> = props => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <SuiviApprenantSearchPage baseRoute={ERoutes.apprenant} />
      </Route>
      <Route path={`${match.path}/:suiviId/:state/hope`} component={SuiviApprenantHopeDetailPage} exact />
      <Route path={`${match.path}/:idSuivi/:state/walter`} exact>
        <SuiviApprenantWalterDetailPage baseRoute={ERoutes.apprenant} />
      </Route>
    </Switch>
  );
};
